// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getStorage } from "firebase/storage";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBcTRENsMAbd2nlfph-t5Dlp9Yepc1eOnQ",
  authDomain: "fileupload001.firebaseapp.com",
  projectId: "fileupload001",
  storageBucket: "fileupload001.appspot.com",
  messagingSenderId: "76357605611",
  appId: "1:76357605611:web:0525b4f2b25bc69f14c6ae",
  measurementId: "G-VB77QF5403",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export const storage = getStorage(app);